(function () {
  const carousels = document.querySelectorAll('[data-category-carousel]');

  carousels.forEach((carousel) => {
    if (carousel.dataset.categoryCarouselReady === 'true') return;

    const cards = Array.from(carousel.querySelectorAll('.home-conversion-panel__category-card'));
    if (cards.length < 2) return;

    carousel.dataset.categoryCarouselReady = 'true';

    let index = 0;
    let intervalId;
    let resumeTimer;
    let scrollTimer;

    const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

    const cardTarget = (card) => {
      const maxScroll = carousel.scrollWidth - carousel.clientWidth;
      const left = card.offsetLeft - carousel.offsetLeft;
      return Math.max(0, Math.min(left, maxScroll));
    };

    const nearestIndex = () => {
      let closest = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      cards.forEach((card, cardIndex) => {
        const distance = Math.abs(cardTarget(card) - carousel.scrollLeft);
        if (distance < closestDistance) {
          closest = cardIndex;
          closestDistance = distance;
        }
      });

      return closest;
    };

    const goTo = (nextIndex) => {
      index = nextIndex % cards.length;
      carousel.scrollTo({
        left: cardTarget(cards[index]),
        behavior: 'smooth',
      });
    };

    const start = () => {
      if (!isMobile() || intervalId || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      intervalId = window.setInterval(() => {
        goTo(index + 1);
      }, 3000);
    };

    const stop = () => {
      window.clearInterval(intervalId);
      intervalId = undefined;
    };

    const resumeLater = () => {
      stop();
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(() => {
        index = nearestIndex();
        start();
      }, 3000);
    };

    carousel.addEventListener('pointerdown', resumeLater, { passive: true });
    carousel.addEventListener('touchstart', resumeLater, { passive: true });
    carousel.addEventListener(
      'scroll',
      () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(() => {
          index = nearestIndex();
        }, 120);
      },
      { passive: true }
    );

    window.addEventListener('resize', () => {
      stop();
      window.clearTimeout(resumeTimer);
      index = nearestIndex();
      start();
    });

    start();
  });
})();
